import * as zod from 'zod';

export const CustomGripperCommand = zod.object({
  kind: zod.literal('CustomGripperCommand'),

  actionID: zod.string(),
});

export type CustomGripperCommand = zod.infer<typeof CustomGripperCommand>;
